<template>
  <modal
    name="dropper"
    :clickToClose="true"
    :resizable="false"
    :scrollable="false"
    :reset="true"
    :height="modalHeight"
    :width="modalWidth"
  >
    <div
      class="centeringparent"
      style="height: 100%; width: 100%"
      v-on:drop.prevent.stop="onDrop"
      v-on:dragover.prevent="onDragOver"
    >
      <div style="width: 100%">
        <progress-bar size="tiny" :val="prgCur" :max="prgTotal" />
      </div>
      <div class="centeringparent" v-if="selectedProject == undefined">
        <div
          class="centeringparent"
          style="max-width: 60%; max-height: 60%; width: 60%; height: 60%"
        >
          <img class="smallerpreview" src="./../assets/worn_forbidden.png" />
          <p class="standardtext">Select a project first</p>
        </div>
      </div>
      <div v-else class="centeringparent picframe">
        <img class="thumbnailpreview" v-bind:src="currentImg" />
      </div>
      <div style="height: 15px" v-if="showingImg > 0">
        <p class="standardtext">{{ doneFiles }}/{{ totFiles }}</p>
      </div>
      <div v-else style="height: 15px"></div>
    </div>
  </modal>
</template>

<script>
import Vue from "vue";
import VModal from "vue-js-modal";
import ProgressBar from "vue-simple-progress";

Vue.use(VModal, { dialog: true });

const MODAL_WIDTH = 656;
const MODAL_HEIGHT = 656;

export default {
  name: "dropper",
  components: { ProgressBar },
  props: {
    selectedProject: Object
  },
  data: function () {
    return {
      currentImg: "",
      modalWidth: MODAL_WIDTH,
      modalHeight: MODAL_HEIGHT,
      numFiles: 0,
      totFiles: 0,
      doneFiles: 0,
      filesQueue: [],
      queueInterval: 0,
      showingImg: false,
      prgTotal: 100,
      prgCur: 0
    };
  },
  created() {},
  methods: {
    checkQueue() {
      console.log(
        `Check queue ${this.filesQueue.length} num files ${this.numFiles}`
      );
      if (this.filesQueue.length <= 0 && this.numFiles == 0) {
        clearInterval(this.queueInterval);
        this.hideDropper();
        this.$emit("onDropComplete");
      } else {
        if (this.filesQueue.length > 0) {
          console.log("Showing img " + this.filesQueue.length.toString());
          this.currentImg = this.filesQueue.pop();
          this.numFiles = this.numFiles - 1;
          this.doneFiles += 1;
          this.showingImg = true;
        }
      }
    },
    addFiles(theNumFiles) {
      this.numFiles += theNumFiles;
      this.totFiles += theNumFiles;
    },
    setFiles(theNumFiles) {
      this.numFiles = theNumFiles;
      this.totFiles = theNumFiles;
      this.doneFiles = 0;
      clearInterval(this.queueInterval);
      this.queueInterval = setInterval(this.checkQueue, 100);
    },
    async showDropper() {
      this.showingImg = false;
      this.numFiles = 0;
      this.doneFiles = 0;
      this.totFiles = 0;
      this.modalWidth =
        window.innerWidth < MODAL_WIDTH ? window.innerWidth * 0.8 : MODAL_WIDTH;
      this.modalHeight =
        window.innerHeight < MODAL_HEIGHT
          ? window.innerHeight * 0.8
          : MODAL_HEIGHT;

      // In the editor component the prop associated to modalWidth would not be immediately updated
      // so we give enough time to Vue to propagate the change
      // in this way the width of the dialog will be properly set
      this.currentImg = "";
      this.prgTotal = 100;
      this.prgCur = 0;
      await this.$nextTick();
      //HtmlSanitizer.AllowedTags['SECTION'] = true;
      //alert(Array.from( this.editor.ui.componentFactory.names() ));
      this.$modal.show("dropper");
    },
    async updateDroppedImg(theDroppedImg) {
      this.filesQueue.unshift(theDroppedImg);
      await this.$nextTick();
    },
    updateUploadProgress(current, total) {
      this.prgCur = current;
      this.prgTotal = total;
    },
    async hideDropper() {
      // only set the current progress bar to 0, if we reset also the total the progress bar
      // will show as it is completed.
      this.prgCur = 0;
      this.$modal.hide("dropper");
    },
    // eslint-disable-next-line no-unused-vars
    onDragOver(eventInfo) {},
    onDrop(eventInfo) {
      this.$emit("onDrop", eventInfo);
    },
    onSave() {
      this.$modal.hide("dropper");
      this.$emit("onSave");
    },
    onDiscard() {
      if (window.confirm("Discard the changes?")) {
        this.$modal.hide("dropper");
      }
    },
    // eslint-disable-next-line no-unused-vars
    onEditorReady(eventInfo) {
      // window.prompt(Array.from( eventInfo.ui.componentFactory.names() ), Array.from( eventInfo.ui.componentFactory.names() ));
    }
  },
  mounted: function () {}
};
</script>
<style>
div.picframe {
  padding: 10px;
  border-style: solid;
  border-color: #28567e;
  border-width: 1px;
  max-width: 60%;
  max-height: 60%;
  width: 60%;
  height: 60%;
  border-radius: 6px;
  margin: 10px;
}
img.smallerpreview {
  max-width: 100%;
  max-height: 100%;
  padding: 60px;
}
</style>
